module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.12966/images/storefront-header-blobs.svg"